import { render, staticRenderFns } from "./AttachmentTag.vue?vue&type=template&id=28ad6382&scoped=true"
import script from "./AttachmentTag.vue?vue&type=script&lang=js"
export * from "./AttachmentTag.vue?vue&type=script&lang=js"
import style0 from "./AttachmentTag.vue?vue&type=style&index=0&id=28ad6382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad6382",
  null
  
)

export default component.exports